module.exports = __webpack_public_path__ + "img/T61.75a79af0.jpg";